import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import NotificationBadge from '../../../components/ui/NotificationBadge';

const LowStockAlerts = () => {
  const navigate = useNavigate();

  const lowStockItems = [
    {
      id: 1,
      name: "PLA Vermelho",
      brand: "Grilon3",
      currentStock: 0.2,
      unit: "kg",
      threshold: 0.5,
      color: "#dc2626",
      urgency: "critical"
    },
    {
      id: 2,
      name: "PETG Transparente",
      brand: "3D Fila",
      currentStock: 0.3,
      unit: "kg",
      threshold: 0.5,
      color: "#transparent",
      urgency: "warning"
    },
    {
      id: 3,
      name: "TPU Preto",
      brand: "FlexiFil",
      currentStock: 0.1,
      unit: "kg",
      threshold: 0.3,
      color: "#000000",
      urgency: "critical"
    }
  ];

  const getUrgencyConfig = (urgency) => {
    const configs = {
      critical: {
        color: 'text-error',
        bgColor: 'bg-error/10',
        borderColor: 'border-error/20',
        icon: 'AlertTriangle',
        label: 'Crítico'
      },
      warning: {
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        borderColor: 'border-warning/20',
        icon: 'AlertCircle',
        label: 'Baixo'
      }
    };
    return configs?.[urgency] || configs?.warning;
  };

  const handleViewInventory = () => {
    navigate('/filament-inventory');
  };

  const criticalCount = lowStockItems?.filter(item => item?.urgency === 'critical')?.length;

  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <h2 className="text-lg font-semibold text-foreground">Alertas de Estoque</h2>
          <NotificationBadge 
            count={criticalCount} 
            variant="error" 
            size="sm"
          />
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleViewInventory}
          iconName="ExternalLink"
          iconPosition="right"
          iconSize={14}
        >
          Ver Estoque
        </Button>
      </div>
      {lowStockItems?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-3" />
          <p className="text-muted-foreground">Todos os filamentos estão com estoque adequado</p>
        </div>
      ) : (
        <div className="space-y-3">
          {lowStockItems?.map((item) => {
            const urgencyConfig = getUrgencyConfig(item?.urgency);
            const stockPercentage = (item?.currentStock / item?.threshold) * 100;
            
            return (
              <div 
                key={item?.id}
                className={`
                  flex items-center space-x-4 p-4 rounded-lg border transition-colors
                  ${urgencyConfig?.borderColor} ${urgencyConfig?.bgColor}
                  hover:bg-opacity-80 cursor-pointer
                `}
                onClick={handleViewInventory}
              >
                {/* Color Swatch */}
                <div className="flex-shrink-0">
                  <div 
                    className="w-8 h-8 rounded-full border-2 border-border"
                    style={{ backgroundColor: item?.color }}
                  />
                </div>
                {/* Item Details */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-medium text-foreground truncate">{item?.name}</h3>
                    <div className="flex items-center space-x-2">
                      <Icon name={urgencyConfig?.icon} size={16} className={urgencyConfig?.color} />
                      <span className={`text-xs font-medium ${urgencyConfig?.color}`}>
                        {urgencyConfig?.label}
                      </span>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between text-sm text-muted-foreground mb-2">
                    <span>{item?.brand}</span>
                    <span>{item?.currentStock}{item?.unit} restante</span>
                  </div>

                  {/* Stock Level Bar */}
                  <div className="w-full bg-muted rounded-full h-2">
                    <div 
                      className={`rounded-full h-2 transition-all duration-300 ${
                        item?.urgency === 'critical' ? 'bg-error' : 'bg-warning'
                      }`}
                      style={{ width: `${Math.min(stockPercentage, 100)}%` }}
                    />
                  </div>
                </div>
                {/* Action Arrow */}
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="text-muted-foreground" 
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LowStockAlerts;